export default __webpack_public_path__ + "static/thumb-landscape-e22e650fcc163bb7e256fc765f02daa8.jpg";